import React, { Component } from 'react';
import graphQlHoc from '../../../components/graphQlHoc';
import query from './DetailpageEpisode.gql';
import NotLoggedIn from '../../../components/notLoggedIn/notLoggedIn';
import ExtendedLink from '../../../components/ExtendedLink/ExtendedLink';

class EpisodeRundown extends Component {
  render() {
    const { loginStatus, episode } = this.props.data;

    if (!loginStatus) {
      return (<NotLoggedIn />);
    }

    return (
      <div className="container container--indent position-relative">
        <div className="gr-12 b-main-title">
          <div className="title">
            <ExtendedLink to={`/episode/${episode.pid}`}>{episode.title}</ExtendedLink>
          </div>
        </div>
        <h1 className="gr-12 gr-9@m">Rundown</h1>
        { window.history && window.history.length > 0
                    && <button type="button" className="b-schedule-page__back-link hide show@m h4-style gr-12 gr-3@m" onClick={() => { window.history.back(); }}>Go back</button>}
        <div className="gr-12 b-rundown" dangerouslySetInnerHTML={{ __html: episode.rundownContent }} />
      </div>
    );
  }
}

export default graphQlHoc(EpisodeRundown, query);
